<template>
  <div class="col-12">
    <h3>OS - {{ this.$route.params.id }}</h3>
    <b-card no-body style="background-color: #F3F3F4">
      <b-tabs card fill v-model="tabIndex">
        <!-- ABA DADOS DO VEÍCULO E OS -->
        <b-tab
          :title="$t('vehicleDataAndOs')"
          :active='tabIndex === 0'
        >
          <form id="osForm" class="mx-auto col-sm-8 col-lg-12" @submit.prevent>

            <div class="row">
              <div class="form-group col-lg-6">
                <label for="garage_accredited">{{ $t('garage_accredited') }}</label>
                <Combobox
                  disabled
                  class="bg-white"
                  name='garage_accredited'
                  :placeholder="$t('select_a_item')"
                  :hasErrors="errors.has('garage_accredited')"
                  :options="oss.garages"
                  :initial-value="os.garageAccredited"
                  :getOptionLabel="garage => customGarageLabel(garage)"
                  v-model="os.garageAccredited"
                  :reduce="garage => garage.id"
                  v-validate="`${validateGarage}`"
                />
                <small v-show="errors.has('garage_accredited')" class="form-text text-muted">
                  {{ errors.first('garage_accredited') }}
                </small>
              </div>

              <div class="form-group col-lg-6">
                <label for="technical_user">{{ $t('technical_user') }}</label>
                <Combobox
                  :disabled='os.services === 5'
                  class="bg-white"
                  name='technical_user'
                  :placeholder="$t('select_a_item')"
                  :options="usersGarageAccredited"
                  :initial-value="os.technicalUsers"
                  label="name"
                  v-model="os.technicalUsers"
                  :reduce="users => users.id"
                />
              </div>
            </div>

            <div class="row">
              <div class="form-group col-lg-4">
                <label for="services">{{ $t('services') }}</label>
                <Combobox
                  :disabled='os.services === 5'
                  class="bg-white"
                  name='services'
                  :placeholder="$t('select_a_item')"
                  label="name"
                  :hasErrors="errors.has('services')"
                  :options="oss.serviceTypes"
                  :initial-value="os.services"
                  v-model="os.services"
                  :reduce='serviceType => serviceType.id'
                  v-validate="'required'"
                />
                <small v-show="errors.has('services')" class="form-text text-muted">
                  {{ errors.first('services') }}
                </small>
              </div>

              <div class="form-group col-lg-4">
                <label for="new_equipment">{{ $t('new_equipment') }}</label>
                <Combobox
                  :disabled='os.services === 4 || os.services === 5 || !os.requireSerial'
                  class="bg-white"
                  name='new_equipment'
                  :placeholder="$t('select_a_item')"
                  :hasErrors="errors.has('new_equipment')"
                  :options="serials"
                  :initial-value="os.serial"
                  v-model="os.serial"
                  v-validate="`${validateNewEquipment}`"
                />

                <small v-show="errors.has('new_equipment')" class="form-text text-muted">
                  {{ errors.first('new_equipment') }}
                </small>
              </div>

              <div class="form-group col-lg-4"  :class="{ 'has-error': errors.has('old_equipment') }">
                <label for="old_equipment">{{ $t('old_equipment') }}</label>
                <input
                  :disabled="os.services == 1 || os.services == 3 || os.services == 5"
                  type="tel"
                  id="old_equipment"
                  name="old_equipment"
                  class="form-control"
                  :placeholder="$t('ph_old_equipment')"
                  v-model="os.withdrawnSerial"
                  v-validate="`${validateOldEquipment}`"
                  @input="searchDataBoardOrSerial('serial')"
                />
                <small v-show="errors.has('old_equipment')" class="form-text text-muted">
                  {{ errors.first('old_equipment') }}
                </small>
              </div>
            </div>

            <b-form-checkbox
              v-show="os.services === 1"
              switch
              id="checkbox-1"
              v-model="os.vehicleAlreadyRegistered"
              name="checkbox-1"
              class="mb-3"
              disabled
            >
              Veículo já cadastrado
            </b-form-checkbox>

            <b-form-checkbox
              v-show="os.services === 2 || os.services === 6"
              switch
              id="checkbox-1"
              v-model="os.requireSerial"
              name="checkbox-1"
              class="mb-3"
              disabled
            >
              Exigir Equipamento Novo
            </b-form-checkbox>

            <div class="row">
              <div class="form-group col-lg-4" :class="{ 'has-error': errors.has('reason') }">
                <label for="reason">{{ $t('reason') }}</label>
                <Combobox
                  :disabled="os.services == 1 || os.services == 4 || os.services == 5"
                  class="bg-white"
                  name='reason'
                  :placeholder="$t('select_a_item')"
                  label="name"
                  :hasErrors="errors.has('reason')"
                  :options="oss.maintanceReasons"
                  :initial-value="os.maintanceReason"
                  v-model="os.maintanceReason"
                  :reduce='maintanceReason => maintanceReason.id'
                  v-validate="`${validateReason}`"
                />
                <small v-show="errors.has('reason')" class="form-text text-muted">
                  {{ errors.first('reason') }}
                </small>
              </div>

              <div class="form-group col-lg-8">
                <label for="contract">{{ $t('contract') }}</label>
                <Combobox
                  :disabled='os.services === 5'
                  class="bg-white"
                  name='contract'
                  :placeholder="$t('select_a_item')"
                  label="contracts"
                  :hasErrors="errors.has('contract')"
                  :options="oss.contracts"
                  :initial-value="os.contract"
                  v-model="os.contract"
                  :reduce='contract => contract.id_contrato'
                  v-validate="`${validateService5}`"
                />
                <small v-show="errors.has('contract')" class="form-text text-muted">
                  {{ errors.first('contract') }}
                </small>
              </div>
            </div>

            <div class="row">
              <div class="form-group col-lg-4" :class="{ 'has-error': errors.has('board') || this.noConfirmBoard }">
                <label for="board">{{ $t('board') }}</label>
                <input
                  :disabled='disabled || os.services === 5'
                  type="text"
                  id="board"
                  name="board"
                  class="form-control"
                  :placeholder="$t('ph_board')"
                  :value="os.board"
                  v-validate="`${validateService5}|max:8|regex:[A-Z]{3}-{1}[0-9]{1}[0-9A-Z]{1}[0-9]{2}`"
                  @input="event => {
                    os.board = event.target.value.toUpperCase()
                    searchDataBoardOrSerial('board')
                  }"
                  maxlength="8"
                />

                <small v-show="errors.has('board')" class="form-text text-muted">
                  {{ errors.first('board') }}
                </small>
              </div>

              <div class="form-group col-lg-4">
                <label for="brand">{{ $t('brand') }}</label>
                <Combobox
                  :disabled='os.services === 5'
                  class="bg-white"
                  name='brand'
                  :placeholder="$t('select_a_item')"
                  :hasErrors="errors.has('brand')"
                  label='name'
                  :reduce='vehicleBrand => vehicleBrand.id'
                  :options="oss.vehicleBrands"
                  :initial-value="os.brand"
                  v-model="os.brand"
                  v-validate="`${validateService5}`"
                />
                <small v-show="errors.has('brand')" class="form-text text-muted">
                  {{ errors.first('brand') }}
                </small>
              </div>

              <div class="form-group col-lg-4" :class="{ 'has-error': errors.has('model') }">
                <label for="model">{{ $t('model') }}</label>
                <input
                  :disabled='os.services === 5'
                  type="text"
                  id="model"
                  name="model"
                  class="form-control"
                  :placeholder="$t('ph_model')"
                  v-model="os.model"
                  v-validate="`${validateService5}`"
                  @input="upper('model')"
                />
                <small v-show="errors.has('model')" class="form-text text-muted">
                  {{ errors.first('model') }}
                </small>
              </div>
            </div>

            <div class="row">
              <div class="form-group col-lg-4" :class="{ 'has-error': errors.has('color') }">
                <label for="color">{{ $t('color') }}</label>
                <input
                  :disabled='os.services === 5'
                  type="text"
                  id="color"
                  name="color"
                  class="form-control"
                  :placeholder="$t('ph_color')"
                  v-model="os.color"
                  v-validate="`${validateService5}`"
                  @input="upper('color')"
                />
                <small v-show="errors.has('color')" class="form-text text-muted">
                  {{ errors.first('color') }}
                </small>
              </div>

              <div class="form-group col-lg-4">
                <label for="year">{{ $t('year') }}</label>
                <Combobox
                  :disabled='os.services === 5'
                  class="bg-white"
                  name='year'
                  :placeholder="$t('select_a_item')"
                  :hasErrors="errors.has('year')"
                  :options="years"
                  :initial-value="os.year"
                  v-model="os.year"
                  v-validate="`${validateService5}`"
                />
                <small v-show="errors.has('year')" class="form-text text-muted">
                  {{ errors.first('year') }}
                </small>
              </div>

              <div class="form-group col-lg-4">
                <label for="vehicle_type">{{ $t('vehicle_type') }}</label>
                <Combobox
                  :disabled='os.services === 5'
                  class="bg-white"
                  name='vehicle_type'
                  :placeholder="$t('select_a_item')"
                  :hasErrors="errors.has('vehicle_type')"
                  :options="oss.vehicleTypes"
                  :initial-value="os.vehicleType"
                  label="TPV_DSC"
                  v-model="os.vehicleType"
                  :reduce="vehicleType => vehicleType.TPV_COD"
                  v-validate="`${validateService5}`"
                />
                <small v-show="errors.has('vehicle_type')" class="form-text text-muted">
                  {{ errors.first('vehicle_type') }}
                </small>
              </div>
            </div>

            <div class="row">
              <div class="form-group col-lg-2" :class="{ 'has-error': errors.has('odometer') }">
                <label for="odometer">{{ $t('odometer') }}</label>
                <CurrencyInput
                  :disabled='os.services === 5'
                  id='odometer'
                  name='odometer'
                  v-model="os.odometer"
                  :currency='null'
                  :precision=1
                  :placeholder="$t('ph_odometer')"
                  :auto-decimal-mode="true"
                  class=" form-control"
                  v-validate="`${validateService5}`"
                  locale='pt-br'
                />
                <small v-show="errors.has('odometer')" class="form-text text-muted">
                  {{ errors.first('odometer') }}
                </small>
              </div>

              <div class="form-group col-lg-2">
                <label for="travel_payment">{{ $t('travel_payment') }}</label>
                <input
                  readonly
                  class="form-control-plaintext"
                  :value="os.travelPayment ? 'SIM' : 'NÃO' "
                >
              </div>

              <div class="form-group col-lg-4" :class="{ 'has-error': errors.has('tracker_installation_local') }">
                <label for="tracker_installation_local">{{ $t('tracker_installation_local') }}</label>
                <input
                  type="text"
                  name="tracker_installation_local"
                  class="form-control"
                  :placeholder="$t('ph_tracker_installation_local')"
                  v-model="os.trackerInstallationLocal"
                  @input="upper('trackerInstallationLocal')"
                />
              </div>

              <div class="col-lg-4">
                <label for="latitude">Latitude/Longitude</label>
                <input
                  class="form-control-plaintext"
                  :value="position.latitude + ' / ' + position.longitude"
                >
              </div>
            </div>

            <div class="row">
              <div class="col-lg-12">
                <label for="obs">{{ $t('obs') }}</label>
                <textarea
                  name="obs"
                  id="obs"
                  rows="3"
                  class="form-control"
                  :placeholder="$t('ph_obs')"
                  v-model="os.obs"
                />
              </div>
            </div>

            <div class="row mt-3 mb-3" id="activeList">
              <div class="col-lg-10 col-sm-4">
                <h3>Lista de ativos</h3>
              </div>

              <div class="col-lg-2 col-sm-2 text-right">
                <button
                  title="Adicionar ativo(s)"
                  :disabled='disabled || os.services === 5 || os.services === 4'
                  class="btn btn-primary"
                  data-toggle="modal"
                  data-target="#modalAddActive"
                >
                  <i class="fas fa-plus" />
                </button>
              </div>
            </div>

            <BootstrapTable
              id="table"
              ref="table"
              class="bg-white"
              :columns="columns"
              :data="activesToAdd"
              :options="options"
            />

            <div class="row mt-3">
              <div class="form-group col-lg-4" :class="{ 'has-error': errors.has('service_date') }">
                <label for="test_date">{{ $t('service_date') }}</label>
                <input
                  type="date"
                  id="test_date"
                  name="test_date"
                  class="form-control"
                  v-model="os.testDate"
                  v-validate="'required'"
                />
                <small v-show="errors.has('test_date')" class="form-text text-muted">
                  {{ errors.first('test_date') }}
                </small>
              </div>
            </div>

            <div class="form-group row">
              <div class="col-sm-4 col-sm-offset-2">
                <LoaderButton
                  data-toggle="modal"
                  data-target="#modalBoardConfirm"
                >
                  {{ $t('save') }}
                </LoaderButton>
              </div>
            </div>

            <!-- MODAL CONFIRM EXCHANGE SERIAL -->
            <div id='modalConfirmExchangeSerial' class="modal fade" tabindex="-1" role="dialog">
              <div class="modal-dialog" role="document">
                <div class="modal-content">
                  <div class="modal-header">
                    <h5 class="modal-title">{{ $t('exchange_serial') }}</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Fechar">
                      <span aria-hidden="true">&times;</span>
                    </button>
                  </div>
                  <div class="modal-body">
                    <b-alert
                      :show="alert.show"
                      @dismissed='alert.show = false'
                      dismissible
                      fade
                      :variant="alert.type"
                    >
                      {{ alert.message }}
                    </b-alert>

                    <h3>{{ $t('confirm_exchange_serial') }}</h3>
                    <p>{{ $t('from') }}: <b>{{ serialInitialOrSelected }}</b></p>
                    <p>{{ $t('to') }}: <b>{{ os.serial }}</b></p>
                  </div>
                  <div class="modal-footer">
                    <button
                      type="button"
                      class="btn btn-secondary m-b"
                      data-dismiss="modal"
                      @click="() => {
                        os.serial = serialInitialOrSelected
                        os.board  = ''
                      }"
                    >
                      {{ $t('close') }}
                    </button>

                    <LoaderButton
                      type="button"
                      class="btn btn-primary"
                      @click="changeSerial"
                    >
                      {{ $t('alter') }}
                    </LoaderButton>
                  </div>
                </div>
              </div>
            </div>

            <!-- MODAL CONFIRM BOARD AND/OR SERIAL -->
            <div class="modal fade" id="modalBoardConfirm" tabindex="-1" role="dialog" aria-labelledby="titleModal" aria-hidden="true">
              <div class="modal-dialog modal-dialog-centered" role="document">
                <div class="modal-content">

                  <div class="modal-header">
                    <h4 class="modal-title" id="titleModal">Confirmação</h4>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Fechar">
                      <span aria-hidden="true">&times;</span>
                    </button>
                  </div>

                  <div class="modal-body" v-if="os.services === 6 && !os.requireWithdrawnSerial">
                    <h1>{{ boardModal }}</h1>

                    <div class="row">
                      <div class="form-group col-12">
                        <label for="digit">{{ $t('digit') }}</label>
                        <input
                          class="form-control"
                          type="text"
                          v-model="digits"
                          :placeholder="$t('ph_digit')"
                        >
                      </div>
                    </div>
                  </div>

                  <div class="modal-body" v-else-if="(os.services === 2 || os.services === 6) && !os.requireSerial">
                    <h1>{{ boardModal }}</h1>

                    <div class="row">
                      <div class="form-group col-12">
                        <label for="digit">{{ $t('digit') }}</label>
                        <input
                          class="form-control"
                          type="text"
                          v-model="digits"
                          :placeholder="$t('ph_digit')"
                        >
                      </div>
                    </div>
                  </div>

                  <div class="modal-body" v-else-if="os.board && os.services !== 5">
                    <div class="form-group text-left" v-if="os.services === 6 || os.services === 2">
                      <b-form-group
                        :class="{ 'has-error': errors.has('equipmentUsed') }"
                      >
                        <p style="font-size: 16px">O equipamento novo <b>({{ os.serial }})</b> foi utilizado?</p>

                        <b-form-radio-group
                          id='equipmentUsed'
                          name='equipmentUsed'
                          v-model="os.equipmentUsedInReinstallation"
                        >
                          <div class="row">
                            <div class="col-12">
                              <b-form-radio size="lg" :value=true>{{ $t('yes_exchange') }}</b-form-radio>
                            </div>
                          </div>
                          <div class="row">
                            <div class="col-12">
                              <b-form-radio
                                size="lg"
                                :value=false
                                button-variant="primary"
                              >
                                {{ $t('no_exchange') }} <b>{{ os.withdrawnSerial }}</b>
                              </b-form-radio>
                            </div>
                          </div>
                        </b-form-radio-group>
                      </b-form-group>
                    </div>

                    <div>
                      <h1>{{ boardModal }}</h1>

                      <div class="row">
                        <div class="form-group col-12">
                          <label for="digit">{{ $t('digit') }}</label>
                          <input
                            class="form-control"
                            type="text"
                            v-model="digits"
                            :placeholder="$t('ph_digit')"
                          >
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="modal-body" v-else-if="os.services === 5">
                    <h3>Iniciar Teste Bancada?</h3>
                  </div>

                  <div class="modal-body" v-else>
                    <h5>É necessário informar a placa do veículo!</h5>
                  </div>

                  <div class="modal-footer" v-if="os.services === 6 && !os.requireWithdrawnSerial">
                    <button
                      type="button"
                      class="btn btn-secondary"
                      data-dismiss="modal"
                    >
                      Voltar
                    </button>

                    <button
                      :disabled="(os.services === 2 && !confirmBoard) || !confirmBoard"
                      type="button"
                      class="btn btn-primary"
                      data-dismiss="modal"
                      data-toggle="modal"
                      @click="openModalConfirmVehicleData"
                    >
                      {{ $t('confirm') }}
                    </button>
                  </div>

                  <div class="modal-footer" v-else-if="(os.services === 2 || os.services === 6) && !os.requireSerial">
                    <button
                      type="button"
                      class="btn btn-secondary"
                      data-dismiss="modal"
                    >
                      Voltar
                    </button>

                    <button
                      :disabled="(os.services === 2 && !confirmBoard) || !confirmBoard"
                      type="button"
                      class="btn btn-primary"
                      data-dismiss="modal"
                      data-toggle="modal"
                      @click="openModalConfirmVehicleData"
                    >
                      {{ $t('confirm') }}
                    </button>
                  </div>

                  <div class="modal-footer" v-else-if="os.board && os.services !== 5">
                    <button type="button" class="btn btn-secondary" data-dismiss="modal">Voltar</button>
                    <button
                      :disabled="((os.services === 2 || os.services === 6) && (!confirmEquipmentUsed || !confirmBoard)) || !confirmBoard"
                      type="button"
                      class="btn btn-primary"
                      data-dismiss="modal"
                      data-toggle="modal"
                      @click="openModalConfirmVehicleData"
                    >
                      {{ $t('confirm') }}
                    </button>
                  </div>

                  <div class="modal-footer" v-else-if="os.services === 5">
                    <button type="button" class="btn btn-secondary" data-dismiss="modal">Voltar</button>
                    <button
                      type="button"
                      class="btn btn-primary"
                      data-dismiss='modal'
                      data-toggle='modal'
                      @click="initStandTest"
                    >
                      {{ $t('start') }}
                    </button>
                  </div>

                  <div class="modal-footer" v-else>
                    <button type="button" class="btn btn-primary" data-dismiss="modal">Ok</button>
                  </div>

                </div>
              </div>
            </div>

            <!-- MODAL CONFIRM VEHICLE DATA -->
            <div
              class="modal fade"
              id="modalConfirmVehicleData"
              tabindex="-1"
              role="dialog"
              aria-labelledby="titleModal"
              aria-hidden="true"
            >
              <div class="modal-dialog modal-dialog-centered" role="document">
                <div class="modal-content">

                  <div class="modal-header">
                    <h4 class="modal-title" id="titleModal">Confirmação</h4>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Fechar">
                      <span aria-hidden="true">&times;</span>
                    </button>
                  </div>

                  <div class="modal-body" v-if="this.os.services !== 5">
                    <p style="font-size: 18px" v-html="getMessageConfirmVehicleData()"></p>
                  </div>

                  <div class="modal-footer">
                    <button
                      type="button"
                      class="btn btn-secondary"
                      data-dismiss="modal"
                    >
                      Voltar
                    </button>

                    <button
                      type="button"
                      class="btn btn-primary"
                      data-dismiss="modal"
                      @click="onClickForm"
                    >
                      {{ $t('confirm') }}
                    </button>
                  </div>

                </div>
              </div>
            </div>

            <!-- MODAL ADD ACTIVE -->
            <div class="modal fade" id="modalAddActive" tabindex="-1" role="dialog" aria-labelledby="modalAddActiveLabel" aria-hidden="true">
              <div class="modal-xl modal-dialog modal-dialog-centered" role="document">
                <div class="modal-content bg-muted">

                  <div class="modal-header">
                    <h5 class="modal-title" id="modalAddActiveLabel">Adicione ativo(s) à OS</h5>
                    <button
                      type="button"
                      class="close"
                      data-dismiss="modal"
                      aria-label="Fechar"
                    >
                      <span aria-hidden="true">&times;</span>
                    </button>
                  </div>

                  <div class="modal-body">
                    <b-alert
                      :show="alert.show"
                      @dismissed='alert.show = false'
                      dismissible
                      fade
                      :variant="alert.type"
                    >
                      {{ alert.message }}
                    </b-alert>

                    <BootstrapTable
                      id="tableAddActive"
                      ref="tableAddActive"
                      class="bg-white"
                      :columns="columnsModalAddActive"
                      :data="showActivesAvailable"
                      @onSort="sort"
                      :options="options"
                    />
                  </div>

                  <div class="modal-footer">
                    <button type="button" class="btn btn-secondary btn-form" data-dismiss="modal">Fechar</button>
                    <button type="button" class="btn btn-primary btn-form" @click='addActive' >Adicionar</button>
                  </div>

                </div>
              </div>
            </div>

            <!-- MODAL DELETE OS -->
            <div class="modal fade" id="modalRemoveActive" tabindex="-1" role="dialog" aria-labelledby="modalRemoveActiveLabel" aria-hidden="true">
              <div class="modal-dialog" role="document">
                <div class="modal-content">
                  <div class="modal-header">
                    <h5 class="modal-title" id="modalRemoveActiveLabel">Remover Ativo</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                      <span aria-hidden="true">&times;</span>
                    </button>
                  </div>
                  <div class="modal-body">
                    <b-alert
                      :show="alert.show"
                      @dismissed='alert.show = false'
                      dismissible
                      fade
                      :variant="alert.type"
                    >
                      {{ alert.message }}
                    </b-alert>

                    <h3>Deseja remover este ativo?</h3>
                    <ul class="list-group">
                      <li id="activeType" class="list-group-item"></li>
                      <li id="manufacturerModel" class="list-group-item"></li>
                      <li id="serie" class="list-group-item"></li>
                    </ul>
                  </div>
                  <div class="modal-footer">
                    <button
                      type="button"
                      :disabled="loadingRemoveActive"
                      class="btn btn-secondary"
                      data-dismiss="modal"
                    >
                      {{ $t('close') }}
                    </button>

                    <button
                      type="button"
                      :disabled="loadingRemoveActive"
                      class="btn btn-danger"
                      @click="removeActive"
                    >
                      <span v-if="loadingRemoveActive" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                      {{ loadingRemoveActive ? $t('removing') + '...' : $t('remove') }}
                    </button>
                  </div>
                </div>
              </div>
            </div>

          </form>
        </b-tab>

        <!-- ABA TESTES -->
        <b-tab
          :title="$t('tests')"
          :disabled='initTest'
          :active='tabIndex === 1'
        >
          <div class="col-12">

            <div class="row text-center">
              <div class="col-md-4">
                <h3>Serial: {{ equipmentData ? equipmentData.EQP_SRN : '' }}</h3>
              </div>
              <div class="col-md-4">
                <h3>Descrição: {{ equipmentData ? equipmentData.VEI_DSC : '' }}</h3>
              </div>
              <div class="col-md-4">
                <h3>Linha: {{ `(${equipmentData ? equipmentData.EQP_DDD : 'XX'}) ${equipmentData ? equipmentData.EQP_TEL : 'XXXX-XXXX'}` }}</h3>
              </div>
            </div>

            <div class="row">
              <div class="col-sm-12">
                <GmapMap
                  :center="{ lat: vehiclePosition.lat || 0, lng: vehiclePosition.lng || 0 }"
                  :zoom="16"
                  map-type-id="roadmap"
                  style="min-width: 100%; height: 300px; border: 1px solid #bbb;"
                >
                  <GmapMarker
                    ref="myMarker"
                    :position="{ lat: vehiclePosition.lat || 0, lng: vehiclePosition.lng || 0 }"
                  />
                </GmapMap>
              </div>
            </div>

            <div class="row text-right mt-3 mb-0">
              <div class="col-12">
                <button
                  v-if="this.user.admin || this.showButtonClearLastDataRead"
                  class="btn btn-secondary"
                  :class="{ 'btn-primary': this.cleared }"
                  @click="clearLastDataRead"
                  title="Limpar último posicionamento"
                >
                  <i class="fas fa-trash-alt" />
                </button>
              </div>
            </div>

            <div class="row">
              <div class="col-lg-2 col-md-4 col-sm-6 col-6 text-center mt-3" data-toggle="tooltip" data-placement="top" title="Data e hora" aria-hidden="false">
                <i
                  class="fa fa-calendar-alt fa-3x"
                  :class="{ 'text-primary': datetimeHasSignal }"
                />
                <br/>
                <h3 class="d-lg-none d-md-none"><span class="badge badge-secondary">Data / Hora</span></h3>
                <h5 class="badge badge-secondary">{{ this.formatDate(vehiclePosition.datetime, 'DD/MM/YYYY HH:mm:ss') }}</h5>
              </div>

              <div class="col-lg-2 col-md-4 col-sm-6 col-6 text-center mt-3" data-toggle="tooltip" data-placement="top" title="Ignição">
                <i
                  class="fa fa-key fa-3x"
                  :class="{ 'text-primary': ignitionHasSignal }"
                />
                <br/>
                <h3 class="d-lg-none d-md-none"><span class="badge badge-secondary">Ignição</span></h3>
              <h5 class="badge badge-secondary">{{ this.formatBoolean(vehiclePosition.ignition) }}</h5>
              </div>

              <div class="col-lg-2 col-md-4 col-sm-6 col-6 text-center mt-3" data-toggle="tooltip" data-placement="top" title="Velocidade">
                <i
                  class="fa fa-tachometer-alt fa-3x"
                  :class="{ 'text-primary': speedHasSignal }"
                />
                <br/>
                <h3 class="d-lg-none d-md-none"><span class="badge badge-secondary">Velocidade</span></h3>
                <h5 class="badge badge-secondary">{{ `${this.formatValue(vehiclePosition.speed)} KM/H` }}</h5>
              </div>

              <div class="col-lg-2 col-md-4 col-sm-6 col-6 text-center mt-3" data-toggle="tooltip" data-placement="top" title="Odômetro">
                <i
                  class="fa fa-tachometer-alt fa-3x"
                  :class="{ 'text-primary': odometerHasSignal }"
                />
                <br/>
                <h3 class="d-lg-none d-md-none"><span class="badge badge-secondary">Odômetro</span></h3>
                <h5 class="badge badge-secondary">{{ `${this.formatOdometer(vehiclePosition.odometer)} KM` }}</h5>
              </div>

              <div class="col-lg-2 col-md-4 col-sm-6 col-6 text-center mt-3" data-toggle="tooltip" data-placement="top" title="GPRS">
                <i
                  class="fa fa-signal fa-3x"
                  :class="{ 'text-primary': gprsHasSignal }"
                />
                <br/>
                <h3 class="d-lg-none d-md-none"><span class="badge badge-secondary">GPRS</span></h3>
                <h5 class="badge badge-secondary">{{ this.formatBoolean(vehiclePosition.gprs) }}</h5>
              </div>

              <div class="col-lg-2 col-md-4 col-sm-6 col-6 text-center mt-3" data-toggle="tooltip" data-placement="top" title="GPS">
                <i
                  class="fa fa-map-marker-alt fa-3x"
                  :class="{ 'text-primary': gpsHasSignal }"
                />
                <br/>
                <h3 class="d-lg-none d-md-none"><span class="badge badge-secondary">GPS</span></h3>
                <h5 class="badge badge-secondary">{{ this.formatBoolean(vehiclePosition.gps) }}</h5>
              </div>
            </div>

            <div class="row">
              <div class="col-lg-2 col-md-4 col-sm-6 col-6 text-center mt-5" data-toggle="tooltip" data-placement="top" title="Pânico">
                <i
                  class="fa fa-exclamation-circle fa-3x"
                  :class="{ 'text-primary': panicHasSignal }"
                />
                <br/>
                <h3 class="d-lg-none d-md-none"><span class="badge badge-secondary">Pânico</span></h3>
                <h5 class="badge badge-secondary" >{{ this.formatBoolean(vehiclePosition.panic) }}</h5>
              </div>

              <div class="col-lg-2 col-md-4 col-sm-6 col-6 text-center mt-5" data-toggle="tooltip" data-placement="top" title="Saída 1">
                <i
                  class="fa fa-lock fa-3x"
                  :class="{ 'text-primary': out1HasSignal }"
                />
                <br/>
                <h3 class="d-lg-none d-md-none"><span class="badge badge-secondary">Saída 1</span></h3>
                <h5 class="badge badge-secondary" >{{ this.formatBoolean(vehiclePosition.out1) }}</h5>
              </div>

              <div class="col-lg-2 col-md-4 col-sm-6 col-6 text-center mt-5" data-toggle="tooltip" data-placement="top" title="Saída 2">
                <i
                  class="fa fa-volume-up fa-3x"
                  :class="{ 'text-primary': out2HasSignal }"
                />
                <br/>
                <h3 class="d-lg-none d-md-none"><span class="badge badge-secondary">Saída 2</span></h3>
                <h5 class="badge badge-secondary" >{{ this.formatBoolean(vehiclePosition.out2) }}</h5>
              </div>

              <div class="col-lg-2 col-md-4 col-sm-6 col-6 text-center mt-5">
                <i
                  class="fa fa-plug fa-3x"
                  title="Entradas"
                  :class="{ 'text-primary': this.inputs }"
                />
                <br/>
                <h3 class="d-lg-none d-md-none"><span class="badge badge-secondary">Entradas 1, 2 e 3</span></h3>
                <h5
                  class="badge badge-secondary mr-1"
                  title="1" >{{ this.formatBoolean(vehiclePosition.in1) }}
                </h5>
                <h5
                  class="badge badge-secondary mr-1"
                  title="2" >{{ this.formatBoolean(vehiclePosition.in2) }}
                </h5>
                <h5
                  class="badge badge-secondary"
                  title="3" >{{ this.formatBoolean(vehiclePosition.in3) }}
                </h5>
              </div>

              <div class="col-lg-2 col-md-4 col-sm-6 col-6 text-center mt-5" data-toggle="tooltip" data-placement="top" title="Voltagem">
                <i
                  class="fas fa-bolt fa-3x"
                  :class="{ 'text-primary': voltage && vehiclePosition.voltage >= 10 }"
                />
                <br/>
                <h3 class="d-lg-none d-md-none"><span class="badge badge-secondary">Voltagem</span></h3>
                <h5 class="badge badge-secondary">{{ this.formatValue(vehiclePosition.voltage) }}</h5>
              </div>

              <div class="col-lg-2 col-md-4 col-sm-6 col-6 text-center mt-5" data-toggle="tooltip" data-placement="top" title="Latitude, Longitude">
                <i
                  class="fa fa-globe fa-3x"
                  :class="{ 'text-primary': latitudeLongitudeHasSignal }"
                />
                <br/>
                <h3 class="d-lg-none d-md-none"><span class="badge badge-secondary">Latitude / Longitude</span></h3>
                <h5 class="badge badge-secondary">{{ `${this.formatValue(vehiclePosition.lat)}, ${this.formatValue(vehiclePosition.lng)}` }}</h5>
              </div>
            </div>

            <div class="row">
              <div class="col-lg-2 col-md-4 col-sm-6 col-6 text-center mt-5" data-toggle="tooltip" data-placement="top" title="Temperatura">
                <i
                  class="fa fa-thermometer-three-quarters fa-3x"
                  :class="{ 'text-primary': temperaturesOk }"
                />
                <br/>
                <h3 class="d-lg-none d-md-none"><span class="badge badge-secondary">Temperatura</span></h3>
                <h5 class="badge badge-secondary" >{{ getTemperature(vehiclePosition.temperatureSensor1) }}</h5>
              </div>
            </div>

            <hr>

            <div class="row text-center">
              <div class="col-lg-2 col-md-4">
                <button
                  id='1'
                  type="button"
                  class="btn btn-block mt-2"
                  :class="{
                    'btn-secondary': this.statusCommand['1'].status == 'notSend',
                    'btn-primary': this.statusCommand['1'].status == 'confirmed',
                    'btn-danger': this.statusCommand['1'].status == 'pending'
                  }"
                  @click="sendCommand">
                  {{ activeOut1 }}
                </button>
              </div>

              <div class="col-lg-2 col-md-4">
                <button
                  id='2'
                  type="button"
                  class="btn btn-block mt-2"
                  :class="{
                    'btn-secondary': this.statusCommand['2'].status == 'notSend',
                    'btn-primary': this.statusCommand['2'].status == 'confirmed',
                    'btn-danger': this.statusCommand['2'].status == 'pending'
                  }"
                  @click="sendCommand">
                  {{ desactiveOut1 }}
                </button>
              </div>

              <div class="col-lg-2 col-md-4">
                <button
                  id='3'
                  type="button"
                  class="btn btn-block mt-2"
                  :class="{
                    'btn-secondary': this.statusCommand['3'].status == 'notSend',
                    'btn-primary': this.statusCommand['3'].status == 'confirmed',
                    'btn-danger': this.statusCommand['3'].status == 'pending'
                  }"
                  @click="sendCommand">
                  {{ desactivePanic }}
                </button>
              </div>

              <div class="col-lg-2 col-md-4">
                <button
                  id='4'
                  type="button"
                  class="btn btn-block mt-2"
                  :class="{
                    'btn-secondary': this.statusCommand['4'].status == 'notSend',
                    'btn-primary': this.statusCommand['4'].status == 'confirmed',
                    'btn-danger': this.statusCommand['4'].status == 'pending'
                  }"
                  @click="sendCommand">
                  {{ activeOut2 }}
                </button>
              </div>

              <div class="col-lg-2 col-md-4">
                <button
                  id='5'
                  type="button"
                  class="btn btn-block mt-2"
                  :class="{
                    'btn-secondary': this.statusCommand['5'].status == 'notSend',
                    'btn-primary': this.statusCommand['5'].status == 'confirmed',
                    'btn-danger': this.statusCommand['5'].status == 'pending'
                  }"
                  @click="sendCommand">
                  {{ desactiveOut2 }}
                </button>
              </div>

              <div class="col-lg-2 col-md-4">
                <LoaderButton
                  @click="verifyError"
                  class='btn-block mt-2'
                  data-toggle="modal"
                  data-target="#modalFailures"
                >
                  {{ $t('finish_test') }}
                </LoaderButton>
              </div>
            </div>

            <!-- MODAL SHOW FAILURES -->
            <div class="modal fade" id="modalFailures" tabindex="-1" role="dialog" aria-labelledby="titleModal" aria-hidden="true">
              <div class="modal-dialog modal-dialog-centered" role="document">
                <div class="modal-content">

                  <div class="modal-header">
                    <h4 class="modal-title" id="titleModal">Falhas</h4>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Fechar">
                      <span aria-hidden="true">&times;</span>
                    </button>
                  </div>

                  <div class="modal-body">
                    <h3>{{ error.length > 0 ? 'Falhas detectadas:' : 'Nenhuma falha detectada' }}</h3>

                    <ul v-if="error.length > 0">
                      <li v-for="err in error" :key="err">{{ err }}</li>
                    </ul>
                  </div>

                  <div class="modal-footer">
                    <button
                      type="button"
                      class="btn btn-secondary"
                      data-dismiss="modal"
                    >
                      {{ $t('close') }}
                    </button>

                    <button
                      type="button"
                      class="btn btn-primary btn-form"
                      data-dismiss="modal"
                      @click='onClickTest'
                    >
                      {{ $t('continue') }}
                    </button>
                  </div>
                </div>
              </div>
            </div>

            <!-- MODAL CONFIRM ACTIVES -->
            <div
              class="modal fade"
              id="modalConfirmActives"
              tabindex="-1"
              role="dialog"
              aria-labelledby="titleModal"
              aria-hidden="true"
            >
              <div class="modal-dialog modal-dialog-centered modal-xl" role="document">
                <div class="modal-content">

                  <div class="modal-header">
                    <h4 class="modal-title" id="titleModal">Confirmar ativos</h4>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Fechar">
                      <span aria-hidden="true">&times;</span>
                    </button>
                  </div>

                  <div class="modal-body">
                    <div class="row">
                      <div
                        v-if="requireTrackerInstallationLocal"
                        class="form-group col-lg-6"
                        :class="{
                          'has-error': errors.has('tracker_installation_local')
                        }"
                      >
                        <label
                          for="tracker_installation_local"
                        >
                          {{ $t('tracker_installation_local') }}
                        </label>

                        <input
                          type="text"
                          name="tracker_installation_local"
                          class="form-control"
                          :placeholder="$t('ph_tracker_installation_local')"
                          v-model="os.trackerInstallationLocal"
                          @input="upper('trackerInstallationLocal')"
                        />
                      </div>

                      <div
                        v-if="requireTrackerInstallationLocal"
                        class="form-group col-lg-3"
                      >
                        <label for="VEI_SEN_TEMP">Sensor de Temperatura</label>
                        <Combobox
                          class="bg-white"
                          name='VEI_SEN_TEMP'
                          :placeholder="$t('select_a_item')"
                          label="label"
                          :initial-value="vehicleDataVerifySerial.VEI_SEN_TEMP"
                          :options="[{ label: 'SIM', value: 1 }, { label: 'NÃO', value: 0 } ]"
                          v-model="vehicleDataVerifySerial.VEI_SEN_TEMP"
                          :reduce="active => active.value"
                        />
                      </div>

                      <div
                        v-if="requireTrackerInstallationLocal"
                        class="form-group col-lg-3"
                      >
                        <label for="VEI_RFID">RFID</label>
                        <Combobox
                          class="bg-white"
                          name='VEI_RFID'
                          :placeholder="$t('select_a_item')"
                          label="label"
                          :initial-value="vehicleDataVerifySerial.VEI_RFID"
                          :options="[{ label: 'SIM', value: 1 }, { label: 'NÃO', value: 0 } ]"
                          v-model="vehicleDataVerifySerial.VEI_RFID"
                          :reduce="active => active.value"
                        />
                      </div>
                    </div>

                    <p>Ativo(s) utilizado(s) ou já existente(s) no veículo</p>
                    <ul>
                      <li v-for="item in allActivesToAdd" :key="item.id">
                        {{ item.activeType.name }} / {{ item.model.manufacturer.name + ' - ' + item.model.name }} / {{ item.serie }}
                      </li>
                    </ul>

                    <hr />

                    <p>Ativo(s) removido(s)</p>
                    <ul>
                      <li v-for="item in allActivesToRemove" :key="item.id">
                        {{ item.activeType.name }} / {{ item.model.manufacturer.name + ' - ' + item.model.name }} / {{ item.serie }}
                      </li>
                    </ul>
                  </div>

                  <div class="modal-footer">
                    <button
                      type="button"
                      class="btn btn-danger"
                      data-dismiss="modal"
                      @click="correctActives"
                    >
                      {{ $t('correct_actives') }}
                    </button>

                    <button
                      type="button"
                      class="btn btn-primary btn-form"
                      data-dismiss="modal"
                      @click='finishTest'
                      :disabled="requireTrackerInstallationLocal && !os.trackerInstallationLocal"
                    >
                      {{ $t('finish') }}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </b-tab>

        <!-- ABA HISTÓRICO -->
        <b-tab
          :title="$t('historic')"
          :disabled='initTest'
          :active='tabIndex === 2'
        >
          <div class="row">
            <div class="col-12 mb-2">
              <button
                v-if="this.user.admin"
                class="btn btn-primary"
                :class="{ 'mr-2': this.user.admin }"
                data-toggle='modal'
                data-target='#modalNewCommand'
                @click="disableCommand = false"
              >
               {{ $t('new_command') }}
              </button>

              <button
                class="btn btn-danger"
                @click="showModalCancelCommand(0)"
              >
               {{ $t('cancel_commands') }}
              </button>
            </div>

            <div class="col-12">
              <b-table
                responsive='xl'
                bordered
                hover
                class="bg-white"
                :items="commandHistoric.rows"
                :fields='fields'
              >
                <template v-slot:cell(commandType)="{ item }">

                  <p v-if="item.description && !user.admin">{{ item.commandType + ' - ' + item.description }}</p>

                  <p v-else-if="item.description && user.admin">
                    <button
                      class="btn btn-sm btn-circle btn-primary"
                      @click="showModalCommand(item)"
                    >
                      <i class="fas fa-pen" />
                    </button>
                    &nbsp;
                    {{ item.commandType + ' - ' + item.description }}
                  </p>

                  <p v-else-if="!user.admin">{{ item.commandType }}</p>
                  <p v-else>
                    <button
                      class="btn btn-sm btn-circle btn-primary"
                      @click="showModalCommand(item)"
                    >
                      <i class="fas fa-plus" />
                    </button>
                    &nbsp;
                    {{ item.commandType }}
                  </p>
                </template>

                <template v-slot:cell(ID_CMD)='{ item }'>
                  <div class="text-center">
                    <button
                      :title="$t('cancel')"
                      class="btn btn-danger btn-circle"
                      @click='showModalCancelCommand(item.ID_CMD)'
                    >
                      <i class="fas fa-ban fa-lg" />
                    </button>
                  </div>
                </template>
              </b-table>
            </div>

            <!-- MODAL NEW COMMAND -->
            <div class="modal fade" id="modalNewCommand" tabindex="-1" role="dialog" aria-labelledby="titleModal" aria-hidden="true">
              <div class="modal-dialog modal-dialog-centered" role="document">

                <div class="modal-content">

                  <div class="modal-header">
                    <h4 class="modal-title" id="titleModal">Cadastrar Comando</h4>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Fechar">
                      <span aria-hidden="true">&times;</span>
                    </button>
                  </div>

                  <div class="modal-body">
                    <b-alert
                      :show="alert.show"
                      @dismissed='alert.show = false'
                      dismissible
                      fade
                      :variant="alert.type || 'success'"
                    >
                      {{ alert.message }}
                    </b-alert>

                    <div class="row">
                      <div class="form-group col-lg-12">
                        <label for="idCommand">{{ $t('idCommand') }}</label>
                        <input
                          :disabled='disableCommand'
                          type="text"
                          id="idCommand"
                          name="idCommand"
                          class="form-control"
                          :placeholder="$t('ph_idCommand')"
                          v-model="commandType.idCommand"
                        >
                      </div>

                      <div class="form-group col-lg-12">
                        <label for="description">{{ $t('description') }}</label>
                        <input
                          type="text"
                          id="description"
                          name="description"
                          class="form-control"
                          :placeholder="$t('ph_description')"
                          v-model="commandType.description"
                        >
                      </div>
                    </div>
                  </div>

                  <div class="modal-footer">
                    <button type="button" class="btn btn-secondary m-b" data-dismiss="modal">Voltar</button>
                    <LoaderButton @click="saveCommand">
                      {{ $t('save') }}
                    </LoaderButton>
                  </div>

                </div>
              </div>
            </div>

            <!-- MODAL CANCEL COMMAND -->
            <div class="modal fade" id="modalCancelCommand" tabindex="-1" role="dialog" aria-labelledby="titleModal" aria-hidden="true">
              <div class="modal-dialog modal-dialog-centered" role="document">

                <div class="modal-content">

                  <div class="modal-header">
                    <h4 class="modal-title" id="titleModal">Cancelar Comando</h4>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Fechar">
                      <span aria-hidden="true">&times;</span>
                    </button>
                  </div>

                  <div class="modal-body">
                    <h3 id="msgConfirmCancelCommand" />
                  </div>

                  <div class="modal-footer">
                    <button
                      type="button"
                      class="btn btn-secondary m-b"
                      data-dismiss="modal"
                    >
                      {{ $t('no') }}
                    </button>

                    <button
                      type="button"
                      class="btn btn-danger m-b"
                      data-dismiss="modal"
                      @click="cancelCommand"
                    >
                      {{ $t('yes') }}
                    </button>
                  </div>

                </div>
              </div>
            </div>
          </div>
        </b-tab>

        <!-- ABA ÚLTIMAS POSIÇÕES -->
        <b-tab
          :title="$t('positionings')"
          :disabled='initTest'
          :active='tabIndex === 3'
        >
          <div class="row">
            <div class="col-12">
              <b-table
                responsive='xl'
                bordered
                hover
                class="bg-white"
                :items="lastPositions"
                :fields='fieldsLastPositions'
              />
            </div>
          </div>
        </b-tab>
      </b-tabs>
    </b-card>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import LoaderButton from '@/components/button/LoaderButton'
import Multiselect from '@/components/form/Multiselect.vue'
import Combobox from '@/components/shared/ComboBox'
import LDBsTable from '@/components/shared/LDBsTable'
import BootstrapTable from 'bootstrap-table/dist/bootstrap-table-vue.esm.js'
import years from '@/config/years.js'
import location from '@/config/locations'
import moment from 'moment-timezone'
import moment2 from 'moment'
import { request } from '@/lib/http'
import _ from 'lodash'

export default {
  name: 'OsForm',
  components: {
    LoaderButton,
    Multiselect,
    Combobox,
    LDBsTable,
    BootstrapTable
  },
  data () {
    return {
      confirmEquipmentUsed       : false,
      disabled                   : true,
      initialOdometer            : undefined,
      locations                  : location,
      usersGarageAccredited      : [],
      years,
      validateGarage             : 'required',
      validateReason             : 'required',
      validateOldEquipment       : 'required',
      validateNewEquipment       : 'required',
      validateService5           : 'required',
      activeSelected             : [],
      model                      : '',
      serie                      : '',
      activeType                 : '',
      garageAccredited           : '',
      confirmBoard               : false,
      noConfirmBoard             : false,
      position: {
        latitude: '',
        longitude: ''
      },
      boardModal                 : '',
      charsToCompare             : '',
      digits                     : '',
      tabIndex                   : 0,
      serialInitialOrSelected    : undefined,
      osData                     : undefined,
      startedTest                : false,
      activeToChange             : undefined,
      showActivesAvailable       : [],
      alert: {
        show: false,
        type: '',
        message: ''
      },
      query                      : {},
      idActiveToRemove           : undefined,
      loadingRemoveActive        : false,
      confirmed                  : false,
      testRestarted              : false,

      // TEST INIT
      columns: [
        {
          key: 'id',
          field: 'id',
          align: 'center',
          width: '100%',
          formatter: function (value, row) {
            let buttons = ''

            if (row.service === 4 || row.activeType.id === 10 || row.activeType.id === 6) {
              return
            }

            if (row.vehicle) {
              buttons += `
                <button
                  title="Remover ativo"
                  data-target="#modalRemoveActive"
                  data-id='${value}'
                  data-active='${row.activeType.name}'
                  data-model='${row.model.name}'
                  data-serie='${row.serie}'
                  data-manufacturer='${row.model.manufacturer.name}'
                  data-toggle="modal"
                  class=" mb-1 btn btn-action btn-danger btn-circle light-bottom-shadow text-white"
                >
                  <i class="fa fa-trash-alt fa-lg" />
                </button>
              `
            } else {
              buttons += `
                <button
                  title="Remover ativo"
                  data-target="#modalRemoveActive"
                  data-id='${value}'
                  data-active='${row.activeType.name}'
                  data-model='${row.model.name}'
                  data-serie='${row.serie}'
                  data-manufacturer='${row.model.manufacturer.name}'
                  data-toggle="modal"
                  class=" mb-1 btn btn-action btn-danger btn-circle light-bottom-shadow text-white"
                >
                  <i class="fa fa-trash-alt fa-lg" />
                </button>
              `
            }

            return buttons
          }
        },
        {
          title: this.$t('serie'),
          field: 'serie',
          sortable: true
        },
        {
          title: this.$t('manufacturer') + '/' + this.$t('model'),
          field: 'model',
          formatter: function(value, row) {
            return row.model.manufacturer.name + ' / ' + value.name
          },
          sortable: true
        },
        {
          title: this.$t('active_type'),
          field: 'activeType.name',
          sortable: true
        }
      ],
      columnsModalChangeActive: [
        {
          radio: true
        },
        {
          title: this.$t('active_type'),
          field: 'activeType.name',
          sortable: true
        },
        {
          title: this.$t('manufacturer') + '/' + this.$t('model'),
          field: 'model',
          formatter: function(value, row) {
            return row.model.manufacturer.name + ' / ' + value.name
          },
          sortable: true
        },
        {
          title: this.$t('serie'),
          field: 'serie',
          sortable: true
        },
        {
          title: this.$t('obs'),
          field: 'obs'
        }
      ],
      columnsModalAddActive: [
        {
          checkbox: true
        },
        {
          title: this.$t('active_type'),
          field: 'activeType.name',
          sortable: true
        },
        {
          title: this.$t('manufacturer') + '/' + this.$t('model'),
          field: 'model',
          formatter: function(value, row) {
            return row.model.manufacturer.name + ' / ' + value.name
          },
          sortable: true
        },
        {
          title: this.$t('serie'),
          field: 'serie',
          sortable: true
        },
        {
          title: this.$t('obs'),
          field: 'obs'
        }
      ],
      options: {
        locale: 'pt-BR'
      },
      activeOut1                 : 'Ativar saída 1',
      desactiveOut1              : 'Desativar saída 1',
      desactivePanic             : 'Desativar pânico',
      activeOut2                 : 'Ativar saída 2',
      desactiveOut2              : 'Desativar saída 2',
      sendOdometer               : 'Enviar odômetro',
      isFirst                    : true,
      interval                   : undefined,
      teste                      : {},
      ignitionOn                 : undefined,
      ignitionOff                : undefined,
      amountIgnitionOn           : 0,
      amountIgnitionOff          : 0,
      panicOn                    : undefined,
      panicOff                   : undefined,
      out1On                     : undefined,
      out1Off                    : undefined,
      out2On                     : undefined,
      out2Off                    : undefined,
      datetimeHasSignal          : false,
      ignitionHasSignal          : false,
      gprsHasSignal              : false,
      gpsHasSignal               : false,
      panicHasSignal             : false,
      panicIsActive              : false,
      out1HasSignal              : false,
      out2HasSignal              : false,
      odometerHasSignal          : false,
      speedHasSignal             : false,
      latitudeLongitudeHasSignal : false,
      temperatures               : [],
      inputs                     : false,
      voltage                    : false,
      odometer                   : undefined,
      lastPosition               : {},
      command                    : undefined,
      error                      : [],
      result                     : '',
      activesUsed                : [],
      initTest                   : true,
      fields: [
        {
          key: 'commandType',
          label: this.$t('command'),
          formatter: (value, key, item) => {
            return item.description
              ? value + ' - ' + item.description
              : value
          }
        },
        { key: 'attemptsMade', label: this.$t('attemptsMade') },
        {
          key: 'status',
          label: this.$t('status'),
          formatter: (value, key, item) => {
            const statusText = item.statusText ? item.statusText : ''
            return value + ' - ' + statusText
          }
        },
        {
          key: 'createAt',
          label: this.$t('createdAt'),
          formatter: (value, key, item) => {
            return moment(value).format('DD-MM-YYYY HH:mm:ss')
          }
        },
        {
          key: 'updatedAt',
          label: this.$t('updatedAt'),
          formatter: (value, key, item) => {
            return moment(value).format('DD-MM-YYYY HH:mm:ss')
          }
        },
        {
          key: 'ID_CMD',
          label: ' '
        }
      ],
      commandType: {
        idCommand: undefined,
        description: ''
      },
      fieldsLastPositions: [
        {
          key: 'timestamp',
          label: this.$t('server_hour'),
          formatter: (value, key, item) => {
            return value
              ? moment(value).tz('America/Recife').add(3, 'h').format('DD/MM/YYYY HH:mm:ss')
              : ''
          }
        },
        {
          key: 'datetime',
          label: this.$t('gps_hour'),
          formatter: (value, key, item) => {
            return value
              ? moment(value).tz('America/Recife').format('DD/MM/YYYY HH:mm:ss')
              : ''
          }
        },
        {
          key: 'ignition',
          label: this.$t('ignition'),
          formatter: (value, key, item) => {
            return value
              ? 'SIM'
              : 'NÃO'
          }
        },
        {
          key: 'speed',
          label: this.$t('speed')
        },
        {
          key: 'odometer',
          label: this.$t('odometer')
        },
        {
          key: 'gprs',
          label: 'GPRS',
          formatter: (value, key, item) => {
            return value
              ? 'SIM'
              : 'NÃO'
          }
        },
        {
          key: 'gps',
          label: 'GPS',
          formatter: (value, key, item) => {
            return value
              ? 'SIM'
              : 'NÃO'
          }
        },
        {
          key: 'panic',
          label: this.$t('panic'),
          formatter: (value, key, item) => {
            return value
              ? 'SIM'
              : 'NÃO'
          }
        },
        {
          key: 'out1',
          label: this.$t('outs_1/2'),
          formatter: (value, key, item) => {
            const out1 = value ? 'SIM' : 'NÃO'
            const out2 = item.out2 ? 'SIM' : 'NÃO'

            return out1 + '/' + out2
          }
        },
        {
          key: 'voltage',
          label: this.$t('voltage'),
          formatter: (value, key, item) => {
            return value + 'V'
          }
        },
        {
          key: 'latitude',
          label: this.$t('lat/lon'),
          formatter: (value, key, item) => {
            return value
              ? value + '/' + item.longitude
              : ''
          }
        },
        {
          key: 'in1',
          label: this.$t('in_1/2/3'),
          formatter: (value, key, item) => {
            const in1 = value ? 'SIM' : 'NÃO'
            const in2 = item.in2 ? 'SIM' : 'NÃO'
            const in3 = item.in3 ? 'SIM' : 'NÃO'

            return in1 + '/' + in2 + '/' + in3
          }
        }
      ],
      disableCommand             : false,
      commandToCancel            : 0,
      timeoutToGetVehicleData    : undefined,
      activesInVehicle           : [],
      activesToRemove            : [],
      activesToAdd               : [],
      showButtonClearLastDataRead: false,
      cleared                    : false,
      lastPositions              : [],
      allActivesToAdd            : [],
      allActivesToRemove         : [],
      testFinished               : false,
      body: {}
    }
  },

  props: {
    os: {
      type: Object,
      default: () => ({
        id: undefined,
        garageAccredited: undefined,
        technicalUsers: undefined,
        serial: '',
        contract: undefined,
        board: '',
        brand: undefined,
        model: '',
        color: '',
        year: '',
        vehicleType: '',
        odometer: undefined,
        services: undefined,
        maintanceReason: undefined,
        withdrawnSerial: undefined,
        obs: '',
        activeList: [],
        testDate: '',
        equipmentUsedInReinstallation: undefined,
        travelPayment: undefined,
        latitude: 0,
        longitude: 0,
        kmTraveled: undefined,
        requireSerial: undefined,
        requireWithdrawnSerial: true,
        vehicleAlreadyRegistered: false,
        trackerInstallationLocal: ''
      })
    }
  },

  computed: {
    ...mapState({
      isLocadados               : state => state.ostests.isLocadados,
      withdrawnSerialIsLocadados: state => state.ostests.withdrawnSerialIsLocadados,
      vehicleData               : state => state.ostests.vehicleData,
      boardExist                : state => state.ostests.boardExist,
      oss                       : state => state.os.all,
      actives                   : state => state.active.all,
      activesAvailableToChange  : state => state.active.allAvailableToChange,

      // TEST INIT
      vehiclePosition           : state => state.ostests.vehiclePosition,
      statusCommand             : state => state.ostests.statusCommand,
      serialData                : state => state.ostests.serialData,
      finished                  : state => state.ostests.finished,
      equipmentData             : state => state.ostests.equipment,
      commandHistoric           : state => state.ostests.commandHistoric,
      user                      : state => state.session.user,
      serials                   : state => state.ostests.serials,
      commandCreated            : state => state.ostests.commandCreated,
      vehicleDataVerifySerial   : state => state.os.vehicleDataVerifySerial,
    }),

    requireTrackerInstallationLocal() {
      return [1, 2, 6].includes(this.os.services)
    },

    temperaturesOk() {
      if (this.temperatures.length < 3) {
        return false
      }

      const last3Temperatures = this.temperatures.slice(-3)

      return last3Temperatures.every(
        temperature => typeof temperature === 'number' && Number.isFinite(temperature) && temperature !== 0
      )
    }
  },

  watch: {
    'os.services': function (service) {
      if (service === 1 || service === 5) {
        this.validateNewEquipment = 'required'
        this.validateOldEquipment = ''
        this.validateReason = ''

        if (service === 5) {
          this.validateGarage = '',
          this.validateService5 = ''
        } else {
          this.validateGarage = 'required',
          this.validateService5 = 'required'
        }

        this.os.withdrawnSerial = undefined
        this.os.maintanceReason = undefined
      }
      if (service === 2 || service === 6) {
        this.validateGarage = 'required'
        this.validateNewEquipment = 'required'
        this.validateOldEquipment = 'required'
        this.validateReason = 'required'
        this.validateService5 = 'required'
      }
      if (service === 4) {
        this.validateGarage = 'required'
        this.validateNewEquipment = ''
        this.validateOldEquipment = 'required'
        this.validateReason = ''
        this.validateService5 = 'required'

        this.os.serial = 0
      }
      // BLOQUEIA ABAS TESTE E HISTÓRICO CASO HAJA ALTERAÇÃO
      if (this.startedTest && service !== this.osData.services) {
        this.blockTabs()
      }
    },
    'os.garageAccredited': async function (id) {
      this.os.technicalUsers = undefined
      this.usersGarageAccredited = []
      if (id) {
        const users = await this.$store.dispatch('garageaccredited/fetchById', id)

        this.usersGarageAccredited = users.users.map(e => {
          return { ...this.usersGarageAccredited, id: e.id, name: e.name }
        })
      }
    },
    'os.board': function (value) {
      this.noConfirmBoard = false
      // BLOQUEIA ABAS TESTE E HISTÓRICO CASO HAJA ALTERAÇÃO
      if (this.startedTest && value !== this.osData.board) {
        this.blockTabs()
      }
    },
    'os.serial': function (value) {
      if (value !== this.serialInitialOrSelected && this.os.services !== 4) {
        $('#modalConfirmExchangeSerial').modal('show')
      }
      // BLOQUEIA ABAS TESTE E HISTÓRICO CASO HAJA ALTERAÇÃO
      if (this.startedTest && value !== this.osData.serial) {
        this.blockTabs()
      }
    },
    'os.withdrawnSerial': function (value) {
      // BLOQUEIA ABAS TESTE E HISTÓRICO CASO HAJA ALTERAÇÃO
      if (this.startedTest && value !== this.osData.withdrawnSerial) {
        this.blockTabs()
      }
    },
    'os.contract': function (value) {
      // BLOQUEIA ABAS TESTE E HISTÓRICO CASO HAJA ALTERAÇÃO
      if (this.startedTest && value !== this.osData.contract) {
        this.blockTabs()
      }
    },
    'os.equipmentUsedInReinstallation': function (value) {
      this.confirmEquipmentUsed = true
    },
    digits: function(value) {
      if (value != undefined) {
        this.digits = this.digits.toUpperCase()
      }

      if (value.length === 2 && value === this.charsToCompare) {
        return this.confirmBoard = true
      }

      return this.confirmBoard = this.confirmed ? true : false
    },
    actives: function(value) {
      this.activesToAdd = value
    },

    amountIgnitionOn: function(value) {
      if (value >= 2 && this.amountIgnitionOff >= 2) {
        this.ignitionHasSignal = true
      }
    },
    amountIgnitionOff: function(value) {
      if (value >= 2 && this.amountIgnitionOn >= 2) {
        this.ignitionHasSignal = true
      }
    },

    // TEST INIT
    vehiclePosition: function (newValue) {
      if (this.isFirst) {
        return false
      }

      const {
        datetime,
        ignition,
        gprs,
        gps,
        panic,
        out1,
        out2,
        voltage,
        lat,
        lng,
        odometer,
        speed,
        timestamp,
        temperatureSensor1
      } = this.vehiclePosition

      // IGNITION
      // VERIFICA SE IGNIÇÃO É DIFERENTE DO ÚLTIMO POSICIONAMENTO
      if (ignition != this.lastPosition.ignition) {

        // SALVA QUANTIDADE DE IGNIÇÃO ON E OFF
        ignition
          ? this.amountIgnitionOn++
          : this.amountIgnitionOff++

        // SE INICIADA DESLIGADA, É NECESSÁRIO LIGAR 2 VEZES
        if (this.teste.ignition == 0) {
          if (this.amountIgnitionOn >= 2) {
            this.ignitionHasSignal = true
          }
        }

        // SE INICIADA LIGADA, BASTA DESLIGAR E LIGAR
        if (this.teste.ignition == 1) {
          if (this.amountIgnitionOn >= 1 && this.amountIgnitionOff >= 1) {
            this.ignitionHasSignal = true
          }
        }

        // this.lastPosition = this.vehiclePosition
      }

      // GPRS
      this.gprsHasSignal = gprs ? true : false

      // GPS
      this.gpsHasSignal = gps ? true : false

      // PANIC
      if (panic) {
        this.panicOn = true
        this.panicIsActive = true
      } else {
        this.panicOff = true
        this.panicIsActive = false
      }

      if (this.panicOn && this.panicOff) {
        this.panicHasSignal = true
      }

      // OUT1
      out1 ? this.out1On = true : this.out1Off = true
      if (this.out1On && this.out1Off) this.out1HasSignal = true

      // OUT2
      out2 ? this.out2On = true : this.out2Off = true
      if (this.out2On && this.out2Off) this.out2HasSignal = true

      // VOLTAGE
      this.voltage = voltage >= 10 ? true : false

      // LATITUDE/LONGITUDE
      this.latitudeLongitudeHasSignal = gps ? true : false

      // ODOMETER
      this.odometerHasSignal = true

      // SPEED
      this.speedHasSignal = true

      this.inputs = true

      if (this.lastPosition.timestamp !== timestamp) {
        // DATETIME
        if ((datetime !== this.teste.datetime) && (moment(datetime).tz('America/Recife').format('YYYY-MM-DD') === moment().tz('America/Recife').format('YYYY-MM-DD'))) {
          this.datetimeHasSignal = true
        }
      }

      this.temperatures.push(temperatureSensor1)

      this.lastPosition = this.vehiclePosition
    }
  },

  methods: {
    ...mapActions('os', [ 'edit', 'cleanState' ]),

    clear() {},

    // TEST FORM
    // EXECUTA QUANDO ALTERADO OFICINA CREDENCIADA
    // BUSCA APENAS OS USUÁRIOS DA OFICINA
    async searchUsersGarageAccredited (id) {
      if (id) {
        const users = await this.$store.dispatch('garageaccredited/fetchById', id)

        this.usersGarageAccredited = users.users.map(e => {
          return { ...this.usersGarageAccredited, id: e.id, name: e.name }
        })
      }
    },
    sort(name, order) {
      console.log(name, order)
    },
    // VERIFICA SERIAIS
    async verifySerial() {
      const {
        services,
        serial,
        withdrawnSerial,
        requireSerial,
        requireWithdrawnSerial
      } = this.os

      // VERIFICA SE EQUIPAMENTO NOVO É LOCADADOS
      // INSTALAÇÃO, MANUTENÇÃO, TESTE BANCADA E REINSTALAÇÃO
      if (services !== 4 && requireSerial) {
        const isLocadados = await this.$store.dispatch('os/fetchVerifySerial', serial)

        if (isLocadados === 'notFound') { // SERIAL NÃO ENCONTRADO
          this.hasError('newSerialNotFound')
          return false
        }
        if (isLocadados.cli_id !== 2 && isLocadados.vei_fld === 0) { // SERIAL COM CLIENTE E ATIVADO-
          this.hasError('newSerialNoLocadados')
          return false
        }
      }
      // VERIFICA SE EQUIPAMENTO ANTIGO NÃO É LOCADADOS
      // MANUTENÇÃO, RETIRADA E REINSTALAÇÃO
      if (services === 2 || services === 4 || (services === 6 && requireWithdrawnSerial)) {
        const isLocadados = await this.$store.dispatch('os/fetchVerifySerial', withdrawnSerial)

        if (isLocadados === 'notFound') {
          this.hasError('oldSerialNotFound')
          return false
        }
        if (isLocadados.cli_id === 2) {
          this.hasError('oldSerialIsLocadados')
          return false
        }
      }

      return true
    },
    // VERIFICA SE EQUIPAMENTO ANTIGO E PLACA ESTÃO NO CONTRATO INFORMADO
    async checkContractAndBoard() {
      const {
        withdrawnSerial,
        board,
        contract
      } = this.os

      const checkContractAndBoard = await this.$store.dispatch('os/fetchCheckContractAndBoard', {
        oldSerial: withdrawnSerial,
        board: board.replace('-', ''),
        contract
      })

      return checkContractAndBoard
        ? true
        : false

    },
    // EXECUTA NO BOTÃO SALVAR DA ABA DADOS DO VEÍCULO
    async onClickForm (evtClick, doneFn) {
      const isValid = await this.$validator.validateAll()
      if (!isValid) {
        const err = new Error(this.$t('invalid_form_fields'))
        this.$store.dispatch('notify/error', err)
        return
      }

      const { dispatch } = this.$store
      const {
        id,
        services,
        contract,
        serial,
        withdrawnSerial,
        equipmentUsedInReinstallation,
        brand,
        requireSerial,
        odometer,
        requireWithdrawnSerial
      } = this.os

      if (!requireSerial) {
        this.os.equipmentUsedInReinstallation = false
      }

      if (odometer === 0) {
        return this.hasError('invalidOdometer')
      }
      if (contract === 0) {
        return this.hasError('invalidContract')
      }
      if (!this.confirmBoard) {
        return this.noConfirmBoard = true
      }

      // VERIFICA SE EQUIPAMENTO ANTIGO E PLACA ESTÃO NO CONTRATO INFORMADO
      // MANUTENÇÃO, RETIRADA OU REINSTALAÇÃO
      if (services === 2 || services === 4 || (services === 6 && requireWithdrawnSerial)) {
        const result = await this.checkContractAndBoard()

        if (!result) {
          return this.hasError('serialNotContract')
        }
      }

      const checked = await this.verifySerial()
      if (!checked) {
        return
      }

      // PEGA OS DADOS DO VEÍCULO A SER TESTADO PELO SERIAL
      const vehicleData = async serial => await dispatch('ostests/fetchVehicleData', { serial })

      // INSTALAÇÃO OU TESTE BANCADA
      if (services === 1 || services === 5) {
        if (this.user.tags.indexOf('clear_last_data_read') >= 0) {
          this.showButtonClearLastDataRead = true
        }

        await vehicleData(serial)
        await dispatch('ostests/equipmentData', { serial })
      }
      // RETIRADA
      if (services === 4) {
        this.showButtonClearLastDataRead = false

        await vehicleData(withdrawnSerial)
        await dispatch('ostests/equipmentData', { serial: withdrawnSerial })
      }
      // MANUTENÇÃO OU REINSTALAÇÃO
      if (services === 2 || services === 6) {
        const getData = async value => {
          await vehicleData(value)
          await dispatch('ostests/equipmentData', { serial: value })
        }

        if (!requireSerial) {
          this.showButtonClearLastDataRead = false

          await getData(withdrawnSerial)
        } else if (equipmentUsedInReinstallation) {
          if (this.user.tags.indexOf('clear_last_data_read') >= 0) {
            this.showButtonClearLastDataRead = true
          }

          await getData(serial)
        } else {
          this.showButtonClearLastDataRead = false

          services === 6 && !requireWithdrawnSerial
            ? await getData(serial)
            : await getData(withdrawnSerial)
        }
      }

      // DEFINE O ID DA MARCA DO VEÍCULO
      if (typeof brand === 'string') {
        const [filter] = this.vehicleBrands.filter(e => e.name === brand)
        this.os.brand = filter.id
      } else if (typeof brand === 'object') {
        this.os.brand = brand.id
      }

      const serialEqual0 = Boolean(services === 4 || (services === 2 && !requireSerial))
      if (serialEqual0) {
        this.os.serial = 0
      }

      // EDITA OS
      const edited = await this.edit({ id, data: this.os })

      if (edited) {
        // SALVA LOG DE INÍCIO DE TESTE
        this.saveLogOs(this.testRestarted ? 'ALTERADO DADOS E REINICIADO TESTE' : 'INICIADO TESTE')

        // INDICA QUE NÃO ESTÁ MAIS NO INÍCIO (FORM)
        this.initTest = false

        // LEVA AO TOPO DA PÁGINA
        const html = document.documentElement
        html.scrollTop = 180

        // FECHA O MODAL
        $('#modalBoardConfirm').modal('hide')

        // CLONA OS DADOS DA OS EM OSDATA PARA COMPARAR ALTERAÇÕES CASO O USUÁRIO RETORNE À ABA DO FORM
        this.osData = Object.assign({}, this.os)

        // DEFINE QUE O TESTE JÁ FOI INICIADO PELO MENOS UMA VEZ
        this.startedTest = true

        // SERVE PARA DIRECIONAR À ABA DE TESTES
        const global = this
        setTimeout(() => global.tabIndex = 1, 500)

        // INICIA O POSICIONAMENTO
        return this.startTimer()
      }

      return
    },
    // EXECUTA PARA EXIBIR MENSAGENS DE ERRO
    hasError(message) {
      return this.$store.dispatch('notify/error', { message }, { root: true })
    },
    // BUSCA DADOS DO VEÍCULO QUANDO INSERIDO A PLACA
    async searchDataBoardOrSerial(search) {
      const {
        id,
        services,
        withdrawnSerial,
        board
      } = this.os
      const { dispatch } = this.$store

      // Define máscara da placa
      if (search === 'board') {
        if (window.event.inputType === 'deleteContentBackward') {
          return
        }

        if (board.length === 3){
          this.os.board = board + '-'
        }

        if (board.length === 4 && !board.includes('-')) {
          this.os.board = board.substr(0,3)+"-"+board.substr(3)
        }
      }

      const stopTimeout = () => clearTimeout(this.timeoutToGetVehicleData)

      const boardValid = /[A-Z]{3}-{1}[0-9]{1}[0-9A-Z]{1}[0-9]{2}/

      if (search === 'board' && (!boardValid.test(board) || board.length !== 8)) {
        return stopTimeout()
      }
      if (search === 'serial' && !withdrawnSerial) {
        return stopTimeout()
      }

      const startTimeout = () => {
        this.timeoutToGetVehicleData = setTimeout(async () => {
          dispatch('overlay/show', true)
          try {
            search === 'serial'
              ? await dispatch('ostests/fetchVehicleData', { serial: withdrawnSerial })
              : await dispatch('ostests/fetchVehicleData', { board: board.replace('-', '') })

            if (this.vehicleData) {
              if (this.vehicleData.VEI_PLC.length === 7 || this.vehicleData.VEI_PLC.length === 8) {
                this.os.board = this.vehicleData.VEI_PLC

                const brandId = this.oss.vehicleBrands.filter(brand => brand.name === this.vehicleData.VEI_MRC)

                this.os.brand = brandId.length > 0
                  ? brandId[0].id
                  : undefined

                this.os.model       = this.vehicleData.VEI_MDL
                this.os.color       = this.vehicleData.VEI_COR
                this.os.year        = this.vehicleData.VEI_ANO
                this.os.vehicleType = this.vehicleData.TPV_COD

                if (services === 1 || services === 5 || services === undefined) {
                  this.os.serial = this.vehicleData.EQP_SRN || undefined
                } else {
                  this.os.withdrawnSerial = this.vehicleData.EQP_SRN
                }

                if (!this.os.contract) {
                  this.os.contract = this.vehicleData.id_contrato || this.os.contract
                }

                if (services && services == 6) {
                  const { EQP_SRN } = this.vehicleData

                  this.os.requireWithdrawnSerial = EQP_SRN == 0
                    ? false
                    : true
                }
              }
            }

            await dispatch('active/loadActivesByService', { idOs: id, service: services, withdrawnSerial: this.os.withdrawnSerial })
          } catch (error) {

          } finally {
            dispatch('overlay/show', false)
          }
        }, 1000)
      }

      stopTimeout()
      startTimeout()
    },
    upper(attribute) {
      this.os[attribute] = this.os[attribute].toUpperCase()
    },
    // PEGA LATITUDE/LONGITUDE DO USUÁRIO
    getLocation() {
      navigator.geolocation.getCurrentPosition(position => {
        this.position = position.coords
        this.os.latitude = position.coords.latitude
        this.os.longitude = position.coords.longitude
      },
      () => {},
      {
        enableHighAccuracy: true
      }
      )
    },
    // GERA ALEATÓRIO DOS 2 DÍGITOS DA PLACA
    // PARA SER CONFIRMADO PELO USUÁRIO ANTES DE INICIAR TESTE
    generateCharsToCompare() {
      this.boardModalTemp = this.os.board.replace('-', '').split('')

      const char1 = Math.floor(Math.random() * 3)
      const char2 = Math.floor(Math.random() * (7 - 3) + 3)

      this.boardModalTemp.map((e, index) => {
        if (index === char1 || index === char2) {
          this.charsToCompare += e
          this.boardModal += '*'
        } else {
          this.boardModal += e
        }
      })
    },
    // ALTERA OS SERIAIS NAS OS`S
    async changeSerial() {
      const { dispatch } = this.$store
      const {
        id,
        serial
      } = this.os

      const exchanged = await dispatch('ostests/fetchExchangeSerial', {
        id,
        newSerial: serial,
        oldSerial: this.serialInitialOrSelected
      })

      if (!exchanged) {
        return this.alert = {
          show: true,
          type: 'danger',
          message: 'Erro ao alterar serial'
        }
      }

      await dispatch("active/fetchFilteredForOs", { idOs: id })

      this.serialInitialOrSelected = serial
      $('#modalConfirmExchangeSerial').modal('hide')
    },

    async initStandTest() {

      const { serial, id } = this.os

      if (this.user.tags.indexOf('clear_last_data_read') >= 0) {
        this.showButtonClearLastDataRead = true
      }

      await this.edit({ id, data: this.os })

      // SALVA LOG DE INÍCIO DE TESTE
      this.saveLogOs(this.testRestarted ? 'ALTERADO DADOS E REINICIADO TESTE' : 'INICIADO TESTE')

      await this.$store.dispatch('ostests/fetchVehicleData', { serial })

      // INDICA QUE NÃO ESTÁ MAIS NO INÍCIO (FORM)
      this.initTest = false

      // LEVA AO TOPO DA PÁGINA
      const html = document.documentElement
      html.scrollTop = 180

      // FECHA O MODAL
      $('#modalBoardConfirm').modal('hide')

      // CLONA OS DADOS DA OS EM OSDATA PARA COMPARAR ALTERAÇÕES CASO O USUÁRIO RETORNE À ABA DO FORM
      this.osData = Object.assign({}, this.os)

      // DEFINE QUE O TESTE JÁ FOI INICIADO PELO MENOS UMA VEZ
      this.startedTest = true

      // SERVE PARA DIRECIONAR À ABA DE TESTES
      const global = this
      setTimeout(() => global.tabIndex = 1, 500)

      // INICIA O POSICIONAMENTO
      return this.startTimer()
    },

    async finishStandTest() {
      const { dispatch } = this.$store

      dispatch('overlay/show', true)

      // DEFINE O ID DA MARCA DO VEÍCULO
      if (typeof brand === 'string') {
        const [brand] = this.vehicleBrands.filter(e => e.name === brand)
        this.os.brand = brand.id
      } else if (typeof brand === 'object') {
        this.os.brand = brand.id
      }

      this.os.board = this.os.board.replace('-', '')

      await dispatch('ostests/fetchFinishedTest', {
        msgFinish: this.result,
        os: this.os,
        activesUsed: this.activesUsed,
        vehicleData: this.vehicleData
      })

      dispatch('overlay/show', false)

      if (!this.finished) {
        return false
      }

      this.testFinished = true

      this.$router.push({ name: 'listostests' })
    },

    async loadAllActives() {
      const $table = $('#tableChangeActive')
      $table.bootstrapTable('showLoading')

      const { dispatch } = this.$store
      const {
        garageAccredited,
        id,
        withdrawnSerial
      } = this.os

      await dispatch('active/getAllAvailableToChange', { garageAccredited, os: id, withdrawnSerial })

      $table.bootstrapTable('hideLoading')
    },

    async addActive() {
      const table = $('#tableAddActive')
      const selected = table.bootstrapTable('getSelections')

      if (selected.length === 0) {
        return this.alert = {
          show: true,
          type: 'danger',
          message: 'Para adicionar, selecione pelo menos 1 (um) ativo.'
        }
      }

      let newActivesToAdd = this.activesToAdd

      for (const item of selected) {
        const exist = this.activesToAdd.filter(active => active.id === item.id)

        if (exist.length > 0) {
          continue
        }

        newActivesToAdd.push(item)
      }

      $('#modalAddActive').modal('hide')
      table.bootstrapTable('uncheckAll')

      return this.activesToAdd.concat(newActivesToAdd)
    },

    async removeActive() {
      const newActivesToAdd = []

      for (const active of this.activesToAdd) {
        active.id === this.idActiveToRemove
          ? this.activesToRemove.push(active)
          : newActivesToAdd.push(active)
      }

      this.activesToAdd = newActivesToAdd
      return $('#modalRemoveActive').modal('hide')
    },

    saveLogOs(action, more = {}) {
      this.$store.dispatch('ostests/saveOsLog', {
        data: {
          ...this.os,
          ...more,
          action
        }
      })
    },

    // TEST INIT
    // EXECUTA NO BOTÃO SALVAR DA ABA TESTES
    async onClickTest() {
      const {
        services,
        brand,
        requireSerial,
        serial,
        withdrawnSerial,
        equipmentUsedInReinstallation,
        requireWithdrawnSerial
      } = this.os
      const { admin } = this.user

      if (!requireSerial) {
        this.os.equipmentUsedInReinstallation = false
      }

      if (services === 5) {
        return setTimeout(() => {
          this.finishStandTest()
        }, 500)
      }

      const { dispatch } = this.$store

      dispatch('overlay/show', true)

      // DEFINE O ID DA MARCA DO VEÍCULO
      if (typeof brand === 'string') {
        const [brand] = this.vehicleBrands.filter(e => e.name === brand)
        this.os.brand = brand.id
      } else if (typeof brand === 'object') {
        this.os.brand = brand.id
      }

      // Se não admin, verifica se pânico está ativo
      if (!admin) {
        const { timestamp } = this.vehiclePosition

        const date = moment2(timestamp)
        const now = moment2().format('YYYY-MM-DD HH:mm')
        const difference = Math.abs(date.diff(now, 'minutes'))

        dispatch('overlay/show', false)
        /**
         * Se último posicionamento ocorreu em menos de 10 minutos
         * e pânico estiver ativo, deve gerar erro e não permitir finalizar OS;
         *
         * Se último posicionamento ocorreu em mais de 10 minutos,
         * OS pode ser finalizada com pânico ativo
         */
        if (difference <= 10 && this.panicIsActive) {
          return this.hasError('panicIsActive')
        }
      }

      // VERIFICA SE EQUIPAMENTO ANTIGO E PLACA ESTÃO NO CONTRATO INFORMADO
      // MANUTENÇÃO, RETIRADA OU REINSTALAÇÃO
      if (services === 2 || services === 4 || (services === 6 && requireWithdrawnSerial)) {
        const result = await this.checkContractAndBoard()

        if (!result) {
          dispatch('overlay/show', false)

          return this.hasError('serialNotContract')
        }
      }

      const checked = await this.verifySerial()
      if (!checked) {
        return dispatch('overlay/show', false)
      }

      if (services === 4) {
        this.activesToRemove = this.activesToAdd
        this.activesToAdd    = []
      }

      let testActivesToAdd    = []
      let testActivesToRemove = []

      if (services === 1) {
        testActivesToAdd     = this.activesToAdd
        testActivesToRemove  = []
        this.activesToRemove = []
      }

      if (services === 2 || services === 6) {
        if (equipmentUsedInReinstallation) {
          for (const active of this.activesToAdd) {
            const { vehicleId, activeType } = active

            if (vehicleId && (activeType.id === 10 || activeType.id === 6)) {
              testActivesToRemove.push(active)
            }

            if (!vehicleId || (activeType.id !== 10 && activeType.id !== 6)) {
              testActivesToAdd.push(active)
            }
          }
        }

        if (!equipmentUsedInReinstallation) {
          testActivesToAdd = this.activesToAdd.filter(active => active.vehicleId || (active.activeType.id !== 10 && active.activeType.id !== 6))
        }

        this.activesToRemove = this.activesToRemove.filter(active => active.vehicleId)
      }

      this.allActivesToAdd    = testActivesToAdd
      this.allActivesToRemove = [...this.activesToRemove, ...testActivesToRemove]

      dispatch('overlay/show', false)

      setTimeout(() => $('#modalConfirmActives').modal('show'), 600)
    },
    async finishTest() {
      const { dispatch } = this.$store

      dispatch('overlay/show', true)

      const lastTemperature = this.temperatures.length
        ? this.temperatures[this.temperatures.length - 1]
        : 0

      this.body = {
        msgFinish: this.result,
        os: {
          ...this.os,
          temperatureSensor: lastTemperature || 0,
          vei_sen_temp: this.vehicleDataVerifySerial.VEI_SEN_TEMP || 0,
          vei_rfid: this.vehicleDataVerifySerial.VEI_RFID || 0,
        },
        vehicleData: this.vehicleData,
        activesToAdd: this.allActivesToAdd,
        activesToRemove: this.allActivesToRemove
      }

      await dispatch('ostests/fetchFinishedTest', this.body)

      dispatch('overlay/show', false)

      if (!this.finished) {
        return false
      }

      this.testFinished = true

      this.$router.push({ name: 'listostests' })
    },
    // PEGA A POSIÇÃO DO EQUIPAMENTO/VEÍCULO
    async setVehiclePosition() {
      if (!this.vehicleData.hasOwnProperty('VEI_ID')) {
        return
      }

      await this.$store.dispatch('ostests/fetchVehiclePosition', this.vehicleData.VEI_ID)

      // this.teste RECEBE OS DADOS DO PRIMEIRO POSICIONAMENTO AO INICIAR TESTE E NÃO MUDA MAIS
      // this.lastPosition RECEBE OS DADOS DO PRIMEIRO POSICIONAMENTO E É ALTERADO A CADA POSICIONAMENTO NOVO
      if (this.isFirst) {
        this.teste        = this.vehiclePosition
        this.lastPosition = this.vehiclePosition
        this.isFirst      = false
      }
    },
    // VERIFICA SE COMANDO FOI CONFIRMADO
    async getConfirmCommand() {
      await this.$store.dispatch('ostests/fetchConfirmCommand')
    },
    // INICIA AS REQUISIÇÕES DE POSIÇÃO, CONFIRMAÇÃO DE COMANDO E HISTÓRICO
    async startTimer() {
      if (this.interval) {
        clearInterval(this.interval)
      }

      const execFunctions = async () => {
        await this.setVehiclePosition()
        await this.getConfirmCommand()
        await this.getHistoricCommand()
        await this.getLastPositions()
      }

      await execFunctions()

      this.interval = setInterval(async () => await execFunctions(), 30000)
    },
    // VERIFICA OS ERROS DO TESTE
    verifyError() {
      this.error = []
      if (!this.datetimeHasSignal) this.error.push('Data e hora')
      if (!this.ignitionHasSignal) this.error.push('Ignição')
      if (!this.vehiclePosition.gprs) this.error.push('GPRS')
      if (!this.vehiclePosition.gps) this.error.push('GPS')
      if (!this.panicHasSignal) this.error.push('Pânico')
      if (this.panicIsActive) this.error.push('Desativar pânico')
      if (!this.out1HasSignal) this.error.push('Saída 1 (Bloqueio)')
      if (!this.out2HasSignal) this.error.push('Saída 2 (Sirene)')
      if (!this.vehiclePosition.voltage) this.error.push('Voltagem')
      if (this.vehiclePosition.voltage < 10) this.error.push('Baixa voltagem')
      if (!this.temperaturesOk) this.error.push('Sensor de Temperatura')

      this.error.length > 0 ? this.result = JSON.stringify(this.error) : this.result = 'FINALIZADO COM SUCESSO!'
    },
    formatDate(date, format) {
      return (typeof date === 'undefined') ? '--/--/---- --:--:--' : moment(date).tz('America/Recife').format(format)
    },
    formatBoolean (value) {
      if (typeof value === 'undefined') return '---'

      return (value) ? 'SIM' : 'NÃO'
    },
    formatValue (value, prefix) {
      prefix = (typeof prefix === 'undefined') ? '' : prefix
      return (typeof value === 'undefined') ? '-----' + prefix : value + prefix
    },
    formatOdometer(value) {
      return value
        ? value / 1000
        : typeof value === 'undefined' ? '-----' : 0
    },
    // ENVIA COMANDOS
    async sendCommand(e) {
      const { id } = e.target

      this.command = id

      const text = document.getElementById(id).innerHTML

      function setTextButton(text) {
        if (id == 1) global.activeOut1     = text || 'Ativar saída 1'
        if (id == 2) global.desactiveOut1  = text || 'Desativar saída 1'
        if (id == 3) global.desactivePanic = text || 'Desativar pânico'
        if (id == 4) global.activeOut2     = text || 'Ativar saída 2'
        if (id == 5) global.desactiveOut2  = text || 'Desativar saída 2'
        if (id == 6) global.sendOdometer   = text || 'Enviar odômetro'
      }

      setTextButton('Enviando...')

      const { dispatch } = this.$store

      await dispatch('ostests/fetchSendCommand', {
        id_tipo_comando_veiculo: id,
        vehicleId              : this.vehicleData.VEI_ID
      })

      if (Object.keys(this.commandCreated).length) {
        this.saveLogOs('ENVIADO COMANDO', this.commandCreated)

        dispatch('ostests/cleanCommandCreated')
      }

      setTextButton('Enviado!')

      setTimeout(() => {
        setTextButton('')
        this.command = undefined
      }, 2000)
    },
    // PEGA HISTÓRICO DE COMANDOS ENVIADOS
    async getHistoricCommand() {
      const {
        services,
        serial,
        withdrawnSerial,
        equipmentUsedInReinstallation,
        requireWithdrawnSerial
      } = this.os

      const history = async serial => {
        this.$store.dispatch('ostests/fetchCommandHistoric', { serial, vehicleId: this.vehicleData.VEI_ID })
      }
      // INSTALAÇÃO OU TESTE BANCADA
      if (services === 1 || services === 5) await history(serial)
      // RETIRADA
      if (services === 4) await history(withdrawnSerial)
      // MANUTENÇÃO OU REINSTALAÇÃO
      if (services === 2 || services === 6) {
        if (services === 6 && !requireWithdrawnSerial) {
          await history(serial)
        } else {
          equipmentUsedInReinstallation
            ? await history(serial)
            : await history(withdrawnSerial)
        }
      }
    },
    // SALVA NOVO COMANDO
    async saveCommand() {
      const result = await this.$store.dispatch('commandtypes/create', { commandType: this.commandType, sendOs: true })

      return result
        ? $('#modalNewCommand').modal('hide')
        : this.alert = {
            show: true,
            type: 'danger',
            message: 'Erro ao salvar comando, verifique se o(s) dado(s) informado(s) já existe(m)'
          }
    },
    // BLOQUEIA ABAS, LIMPA HISTÓRICO, COMANDOS E PARA O POSICIONAMENTO
    blockTabs() {
      this.initTest      = true
      this.testRestarted = true

      if (this.interval) {
        clearInterval(this.interval)
      }

      this.$store.dispatch('ostests/cleanPartialState')

      this.ignitionOn                 = undefined
      this.ignitionOff                = undefined
      this.panicOn                    = undefined
      this.panicOff                   = undefined
      this.out1On                     = undefined
      this.out1Off                    = undefined
      this.out2On                     = undefined
      this.out2Off                    = undefined
      this.datetimeHasSignal          = false
      this.ignitionHasSignal          = false
      this.gprsHasSignal              = false
      this.gpsHasSignal               = false
      this.panicHasSignal             = false
      this.panicIsActive              = false
      this.out1HasSignal              = false
      this.out2HasSignal              = false
      this.latitudeLongitudeHasSignal = false
      this.voltage                    = false
      this.odometer                   = undefined
      this.temperatures               = []
    },
    showModalCommand(item) {
      this.disableCommand = true

      if (item.description) {
        this.commandType.idCommand = item.commandType
        this.commandType.description = item.description
        $('#modalNewCommand').modal('show')
      } else {
        this.commandType.idCommand = item.commandType
        $('#modalNewCommand').modal('show')
      }
    },
    // ATIVA MODAL DE CONFIRMAÇÃO DE CANCELAMENTO DOS COMANDOS ENVIADOS
    showModalCancelCommand(id) {

      const msg = $('#modalCancelCommand').find('#msgConfirmCancelCommand')

      id > 0
        ? msg.text('Confirma cancelamento deste comando?')
        : msg.text('Confirma cancelamento de todos os comandos?')

      this.commandToCancel = id
      $('#modalCancelCommand').modal('show')

    },
    async cancelCommand() {
      const {
        services,
        serial,
        withdrawnSerial,
        equipmentUsedInReinstallation
      } = this.os

      let equipment

      // INSTALAÇÃO OU TESTE BANCADA
      if (services === 1 || services === 5) {
        equipment = serial
      }
      // RETIRADA
      if (services === 4) {
        equipment = withdrawnSerial
      }
      // MANUTENÇÃO OU REINSTALAÇÃO
      if (services === 2 || services === 6) {
        equipmentUsedInReinstallation
          ? equipment = serial
          : equipment = withdrawnSerial
      }

      const { dispatch } = this.$store

      const cancelled = await dispatch('ostests/cancelCommand', {
        command  : this.commandToCancel,
        vehicleId: this.vehicleData.VEI_ID,
        equipment
      })

      if (cancelled) {
        this.commandToCancel > 0
          ? this.saveLogOs('COMANDO CANCELADO (INDIVIDUAL)', { commandId: this.commandToCancel })
          : this.saveLogOs('COMANDO CANCELADO (TODOS)', { vehicleId: this.vehicleData.VEI_ID })
      }
    },
    async clearLastDataRead() {
      try {
        await request({
          url: `clear-last-data-read/${this.os.serial}`,
          method: 'get'
        })

        this.saveLogOs('REMOVIDO ÚLTIMO DADO LIDO')

        this.cleared = true

        this.$store.dispatch('ostests/cleanPartialState')

        this.ignitionOn                 = undefined
        this.ignitionOff                = undefined
        this.panicOn                    = undefined
        this.panicOff                   = undefined
        this.out1On                     = undefined
        this.out1Off                    = undefined
        this.out2On                     = undefined
        this.out2Off                    = undefined
        this.datetimeHasSignal          = false
        this.ignitionHasSignal          = false
        this.gprsHasSignal              = false
        this.gpsHasSignal               = false
        this.panicHasSignal             = false
        this.panicIsActive              = false
        this.out1HasSignal              = false
        this.out2HasSignal              = false
        this.latitudeLongitudeHasSignal = false
        this.voltage                    = false
        this.odometer                   = undefined
        this.speedHasSignal             = false
        this.odometerHasSignal          = false
        this.inputs                     = false
        this.amountIgnitionOn           = 0
        this.amountIgnitionOff          = 0
        this.temperatures               = []
      } catch (error) {}
    },
    // PEGA ÚLTIMAS POSIÇÕES
    async getLastPositions() {

      try {
        const positions = await request({
          url   : 'last-positions',
          method: 'get',
          params: { vehicleId: this.vehicleData.VEI_ID }
        })

        this.lastPositions = positions
      } catch (error) {}
    },
    openModalConfirmVehicleData() {
      $('#modalConfirmVehicleData').modal('show')
    },
    getMessageConfirmVehicleData() {
      let service  = {}
      let contract = {}
      let brand    = ''

      try {
        if (typeof this.os.brand === 'number' && this.oss.vehicleBrands) {
          const { name } = this.oss.vehicleBrands.find(brand => brand.id === this.os.brand)
          brand = name
        } else if (this.os.brand !== null && typeof this.os.brand === 'object') {
          brand = this.os.brand.name
        }
        if (this.oss.serviceTypes) {
          service = this.oss.serviceTypes.find(service => service.id === this.os.services)
        }
        if (this.oss.contracts) {
          contract = this.oss.contracts.find(contract => contract.id_contrato === this.os.contract)
        }

        return `Você está iniciando um teste de <strong>${service.name}</strong> para o cliente <strong>${contract.contracts}</strong> da placa <strong>${this.os.board}</strong> [<strong>${this.os.model}</strong> - <strong>${brand}</strong> - <strong>${this.os.color}</strong> - <strong>${this.os.year}</strong>], deseja confirmar?"`
      } catch (error) {
        return ''
      }
    },
    correctActives() {
      setTimeout(() => this.tabIndex = 0, 500)

      setTimeout(() => {
        let element = document.querySelector("#activeList")
        element.scrollIntoView({ behavior: 'smooth' })
      }, 700)
    },

    customGarageLabel(garage) {
      const info = [garage.fantasyName]

      const city = _.get(garage, 'city', '')
      const uf = _.get(garage, 'uf', '')

      city && info.push(city.toUpperCase())
      uf && info.push(uf.toUpperCase())

      return info.join(' - ')
    },

    getTemperature(value) {
      if (value === null || value === undefined) {
        return "-"
      }

      return value
    }
  },

  // EMITE ALERTA QUANDO NÃO PREENCHIDO COM CONTRATO > 0
  beforeMount() {
    if (this.os.contract === 0) this.os.contract = undefined
  },

  async mounted () {
    const { dispatch } = this.$store
    const {
      services,
      id,
      odometer,
      garageAccredited,
      serial,
      withdrawnSerial,
      board,
      requireSerial
    } = this.os

    if (board.length === 7) {
      this.os.board = board.substr(0,3)+"-"+board.substr(3,7)
    }

    dispatch('overlay/show', true)

    if (services !== 5) {
      await dispatch('ostests/fetchAllSerials')
      await dispatch('active/loadActivesByService', { idOs: id, service: services })
      await dispatch('active/getAllAvailableToChange', { garageAccredited, os: id, service: services })

      this.activesToAdd = this.actives
      this.showActivesAvailable = this.activesAvailableToChange.filter(item => ![6, 10].includes(item.activeType.id))
    }

    this.initialOdometer = odometer
    this.os.testDate = moment().tz('America/Recife').format('YYYY-MM-DD')

    await dispatch('os/fetchAllPageOsForm')

    if (garageAccredited) {
      await this.searchUsersGarageAccredited(garageAccredited)
    }

    let obj = {}

    obj = services === 1 || services === 5
      ? { serial }
      : { board: board.replace('-', '') }

    await dispatch('ostests/fetchVehicleData', obj)

    // DEFINE OBRIGATORIEDADE DE ALGUNS CAMPOS
    if (services === 1 || services === 5) {
      this.validateGarage = 'required'
      this.validateNewEquipment = 'required'
      this.validateOldEquipment = ''
      this.validateReason = ''
    }
    if (services === 2 || services === 6) {
      this.validateNewEquipment = requireSerial ? 'required' : ''
      this.validateOldEquipment = 'required'
      this.validateReason = 'required'
    }
    if (services === 4) {
      this.validateNewEquipment = ''
      this.validateOldEquipment = 'required'
      this.validateReason = ''
    }

    // CASOS DE REINSTALAÇÃO EM VEÍCULOS DESATIVADOS OU APENAS DE SOFTWARE
    if (services === 6) {
      if (withdrawnSerial == 0) {
        this.os.requireWithdrawnSerial = false
      }

      if (withdrawnSerial > 0) {
        this.os.requireWithdrawnSerial = true
      }
    }

    await dispatch('overlay/show', false)
    this.disabled = false

    this.getLocation()

    const global = this
    $('#modalBoardConfirm').on('show.bs.modal', function () {
      global.generateCharsToCompare()
    })

    $('#modalBoardConfirm').on('hide.bs.modal', function () {
      global.charsToCompare = []
      global.boardModal = ''
      global.digits = ''
    })

    $('#modalConfirmVehicleData').on('show.bs.modal', function () {
      global.confirmed = true
    })

    $('#modalConfirmVehicleData').on('hide.bs.modal', function () {
      setTimeout(() => {
        global.confirmed    = false
        global.confirmBoard = false
      }, 5000)
    })

    $('#modalNewCommand').on('hide.bs.modal', function () {
      global.commandType = {
        idCommand: undefined,
        description: ''
      }
      global.alert = {
        show: false,
        type: '',
        message: ''
      }
    })

    $('#modalAddActive').on('hide.bs.modal', function () {
      global.alert.show = false
    })

    $('#modalRemoveActive').on('show.bs.modal', function (event) {
      const button = $(event.relatedTarget)
      const modal = $(this)
      modal.find('#activeType').text(`Tipo de ativo: ${button.data('active')}`)
      modal.find('#manufacturerModel').text(`Fabricante/Modelo: ${button.data('manufacturer')} / ${button.data('model')}`)
      modal.find('#serie').text(`Serial: ${button.data('serie')}`)
      global.idActiveToRemove = button.data('id')
    })

    $('#modalRemoveActive').on('hide.bs.modal', function (event) {
      global.idActiveToRemove = undefined
      global.alert.show = false
    })

    this.serialInitialOrSelected = serial

    obj = services !== 4 && requireSerial
      ? { serial }
      : { serial: withdrawnSerial }

    await dispatch('ostests/equipmentData', obj)

    await this.setVehiclePosition()

    $('#toolbar')
      .find('div:first')
      .append('<a id="toggleSearch" class="btn btn-secondary text-white" data-toggle="collapse" data-target="#formListActive" aria-expanded="true" aria-controls="formListActive" data-toggle="button"><i class="fa fa-search"></i></a>')

    $('[name=refresh]').click(function () {
      $('#clear').trigger('click')
      $('#search').trigger('click')
    })
  },

  destroyed () {
    this.saveLogOs(this.testFinished ? 'OS FINALIZADA' : 'OS NÃO FINALIZADA', this.body)

    if (this.interval) {
      clearInterval(this.interval)
    }

    const { dispatch } = this.$store

    dispatch('active/cleanState')
    dispatch('ostests/cleanState')
    this.cleanState()
  }
}
</script>

<style>
.nav-link {
  color: #6b6b6b !important;
}
.nav-link.active {
  color: black !important;
}
</style>
